import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import dynamic from "next/dynamic";
import { connect, useDispatch } from "react-redux";

import {
  addCouponToCart,
  deleteItemsFromCart,
  updateItemsofCart,
  removeCouponFromCart,
  getShippingAndBilling,
  showGuestCart,
  addGuestCartProducts,
  resetGuestCart,
} from "Redux/actions/cartAction";
import { checkFeatures } from "Redux/actions/commonAction";
import {
  setProfileData,
  setCheckoutLogin,
} from "Redux/actions/navAction";
import { SYNC_USER_PROFILE_SUCCESS } from "Redux/actionTypes/index";
import {
  resetSyncUserProfile,
  syncUserProfile,
} from "Redux/actions/userProfileAction";
import { setHelpLeadBucket } from "Redux/actions/getHelpAction";
import {
  setChangeStore,
  setChangeMethods,
  setStoreDetails,
} from "Redux/actions/geoLocationAction";

import * as ActionTypes from "Redux/actionTypes";

import * as Analytics from "services/analyticsUtag";
import * as pageAPI from "services/pageService";
import { handoverUpgradeeSession } from "services/upgradeService";
import { updateTheCartWithVASProduct } from "services/vasDataService";

import ajaxService from "utils/ajaxServices";
import {
  getCartGrandTotal,
  getFinalPrice,
  getAmountOffValue,
  getCookieValue,
  componentResize,
  componentCheckSize,
  calculateShipping,
  getProductsCookie,
  setCookieConsentWrapper,
  isArrayNotEmpty,
  splitCartItems,
  clearUserToken,
  handleCartActionFailure,
  getCustomerActiveCartService,
  getAuthToken,
  formatNumbersWithComma,
  mapCartProductItems,
  createMarkup,
} from "utils/helperServices";

import config from "../../config/index";
import labels from "../../config/labels";
import errorMessages from "../../config/errorMessages";
import { cookie_category } from "../../config/index";
import { CartRecentProducts } from "../../config/queries";

import { parseCookies } from "../../lib/parseCookies";

import {
  Row,
  Col,
  Container,
  Modal,
  CustomContainer,
  useRouter,
  Cookie,
} from "components/atoms/DependencyHelper";

import LoginModal from "components/atoms/loginModal/LoginModal";
import PageHeading from "components/atoms/pageHeading/PageHeading";
import ErrorCard from "components/molecules/errorCard/ErrorCard";
import InfoBox from "components/atoms/infoBox/InfoBox";
import InfoClickCollect from "components/atoms/infoClickCollect/InfoClickCollect";
import Seo from "components/atoms/Seo/Seo";
import CartListContainer from "components/organisms/CartListContainer/CartListContainer";
import PendingOrder from "components/atoms/pendingOrder/PendingOrder";
import ErrorTooltip from "components/molecules/errorToolTip/ErrorTooltip";

import types from "../../config/types";
import { LEAD_BUCKETS } from "../../config/constants";

const CartOrderSummary = dynamic(
  import("../../components/molecules/cartOrderSummary/CartOrderSummary"),
  { ssr: false }
);
const TextBoxCard = dynamic(
  import("../../components/atoms/textBox/textBoxCard/TextBoxCard"),
  { ssr: false }
);
const LabelText = dynamic(import("../../components/atoms/label/LabelText"), {
  ssr: false,
});
const SnackBar = dynamic(import("../../components/atoms/snackBar/SnackBar"), {
  ssr: false,
});
const CTAButton = dynamic(
  import("../../components/atoms/CTAButton/CTAButton"),
  {
    ssr: false,
  }
);
const Image = dynamic(import("../../components/atoms/image/image"), {
  ssr: false,
});
const CartOrderDescription = dynamic(
  import(
    "../../components/molecules/cartOrderDescription/CartOrderDescription"
  ),
  { ssr: false }
);
const PromoTextCard = dynamic(
  import("../../components/atoms/textBox/promoTextCard/PromoTextCard"),
  { ssr: false }
);
const CartFooter = dynamic(
  import("../../components/organisms/CartFooter/CartFooter"),
  { ssr: false }
);

const CartPage = ({
  recentlyViewed,
  cartProductItems,
  prices,
  metadata,
  addCouponToCart,
  errorMsg,
  cartDetails,
  userLoggedIn,
  profileData,
  isCheckoutLogin,
  deleteItemsFromCart,
  updateItemsofCart,
  profileLoading,
  removeCouponFromCart,
  getShippingAndBilling,
  showGuestCart,
  resetSyncUserProfile,
  syncUserProfile,
  setProfileData,
  setCheckoutLogin,
  userProfileSync,
  addGuestCartProducts,
  canReciveOTP,
  isChildAllowed,
  upgradeResponse,
  resetGuestCart,
  setHelpLeadBucket,
  geoLocation,
  setChangeStore,
  setStoreDetails,
  setChangeMethods,
  isMiniApp,
  features,
  checkFeatures,
}) => {
  const env = config.env;
  const imagePrefix = config.envConfigs[env].imagePrefix;
  const urlPrefix = config.envConfigs[env].shoppingUrlPrefix;
  const loginUrl = config.envConfigs[env].DIDLoginUrl;
  const legacyEnv = config.envConfigs[env].legacyEnv;
  const [redirectURL, setRedirectURL] = useState("");
  const productsCookie = getCookieValue("products");
  const cartId = getCookieValue("cart_id");
  const [productsViewed, setProductsViewed] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [positionFromTop, setPositionFromTop] = useState();
  const [updatedCookieProduct, setUpdatedCookieProduct] = useState(
    recentlyViewed ? recentlyViewed : []
  );

  const [cartItems, setCartItems] = useState([]);
  const [allPrices, setAllPrices] = useState(null);

  const [productItems, setProductItems] = useState([]);
  const [updateCartDetails, setUpdateCartDetails] = useState("");
  const [continueDisabled, setContinueDisabled] = useState(false);

  const [text, setText] = useState("");
  const [showCouponAlert, setShowCouponAlert] = useState(false);
  const [showSnackBar, setShowSnackBar] = useState(false);
  const [addCouponMsg, setAddCoupon] = useState(false);
  const [updateMsg, setUpdateMsg] = useState(false);
  const [removeMsg, setRemoveMsg] = useState(false);
  const [removeCoupon, setRemoveCoupon] = useState(false);
  const [isDealRemove, setIsDealRemove] = useState(false);
  const [cartProductName, setCartProductName] = useState(null);
  const [cartApiError, setCartApiError] = useState(false);
  const [refreshUser, setRefreshUser] = useState(false);
  const [isUserProfileSync, setIsUserProfileSync] = useState(false);
  const [checkoutDisabled, setCheckoutDisabled] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [hideVasModal, setHideVasModal] = useState(false);
  const [showPreOrderInfo, setShowPreOrderInfo] = useState(false);
  const [preOrderDeliveryMessage, setPreOrderDeliveryMessage] = useState("");
  const [startEmptyCart, setStartEmptyCart] = useState({});

  let repeatedDealVas = [];
  const isPendingOrder = cartDetails.notificationData?.is_pending_orders
    ? true
    : false;
  const [voucherAnalytics, setVoucherAnalytics] = useState({});

  const isMobile = componentResize();
  const isTablet = componentCheckSize() <= 992;
  const router = useRouter();

  const dispatch = useDispatch();
  const setLoadingState = (isLoading) => dispatch({
    type: ActionTypes.SET_IS_LOADING,
    payload: isLoading
  });

  
  const newRedirectURL = (features?.shakaEnabled && features?.shakaEnabled !== undefined) ? 'checkout' : 'shopping';

  const handleChange = (e) => {
    setText(e.target.value);
  };

  async function updateGeoLocationState() {
    if (geoLocation) {
      if (geoLocation?.storeDetails) {
        setStoreDetails(false);
        setChangeMethods(false);
        setChangeStore(false);
      }
    }
  }

  useEffect(() => {
    checkFeatures();
    window.scrollTo(0, 0);

    setTimeout(() => {
      const headerFragment = document.getElementById("headerFragment");
      let fragmentHeight;
      if (headerFragment) {
        fragmentHeight = headerFragment?.offsetHeight || 0;
        setPositionFromTop(fragmentHeight);
      }
    }, 1000);

    setHelpLeadBucket(LEAD_BUCKETS.general);
    updateGeoLocationState();
    emptyCartContainer();
  }, []);

  const btnConfig = {
    buttonStyle: "outline black",
    buttonLabel: "Start shopping",
  };

  const emptyCartContainer = async () => {
    let emptyContainerData;
    try {
      const resultData = await ajaxService.httpGet(
        "drupalBaseUrl",
        "",
        "api",
        "shoppingCartEmpty"
      );

      if (resultData.status === "success") {
        emptyContainerData = {
          icon: resultData.sections[0].items[0].icon,
          title: resultData.sections[0].items[0].title,
          callToActionUri: resultData.sections[0].callToActionUri,
          callToActionLabel: resultData.sections[0].callToActionLabel,
        };
      } else {
        throw new Error();
      }
    } catch (e) {
      console.log("error", e);
      emptyContainerData = {
        icon: `${imagePrefix}/assets/images/cart-o-copy.svg`,
        title: labels?.lbl_empty_cart_msg,
        callToActionUri: "internal:/products",
        callToActionLabel: btnConfig?.buttonLabel,
      };
    } finally {
      setStartEmptyCart(emptyContainerData);
    }
  };

  useEffect(() => {
    const { allow_place_order } = cartDetails;
    if (
      typeof allow_place_order !== "undefined" &&
      Number(allow_place_order) === 0
    ) {
      setCheckoutDisabled(true);
    } else {
      setCheckoutDisabled(false);
    }
  }, [cartDetails?.allow_place_order]);

  let monthlyCartProducts,
    repeatedDeal = [];
  let duplicateVas = false,
    maxVas = 0;

  const { dealCartProducts, onceOffCartProducts } =
    splitCartItems(cartProductItems);

  monthlyCartProducts = dealCartProducts;
  // ??? CQ
  for (const item of dealCartProducts) {
    for (let index = 0; index < item.quantity; index++) {
      repeatedDeal.push(item);
    }
  }

  monthlyCartProducts = repeatedDeal;
  const filteredDeals = monthlyCartProducts.filter(
    (deal) => deal?.product?.is_deal_product === 1
  );
  const manyMonthlyDeals = filteredDeals?.length > 1;

  useEffect(() => {
    if (manyMonthlyDeals) {
      filteredDeals.forEach((deal) => {
        if (deal?.product?.is_deal_product === 1 && deal?.quantity > 1) {
          updateCartProduct(cartId, deal?.id, 1, true);
        }
      });
    }
  }, [manyMonthlyDeals]);

  let dealSku = "",
    monthlyCartVasProducts = [];
  if (Array.isArray(dealCartProducts)) {
    dealCartProducts.forEach((item) => {
      dealSku = item?.product?.sku;
      cartProductItems.forEach((item) => {
        if (item?.parent_product_sku && item?.parent_product_sku == dealSku) {
          monthlyCartVasProducts.push(item);
        }
      });
    });
  } else {
    dealSku = monthlyCartProducts?.product?.sku;
    monthlyCartVasProducts = cartProductItems.filter(
      (cartProduct) =>
        cartProduct?.monthly_recurring &&
        cartProduct?.parent_product_sku == dealSku
    );
  }

  for (const item of monthlyCartVasProducts) {
    for (let index = 0; index < item.quantity; index++) {
      repeatedDealVas.push(item);
    }
  }

  monthlyCartVasProducts = repeatedDealVas;

  if (Array.isArray(monthlyCartVasProducts)) {
    for (const item of monthlyCartVasProducts) {
      monthlyCartProducts.push(item);
      maxVas++;
    }
  }

  monthlyCartVasProducts
    .map((v) => v?.product?.sku)
    .sort()
    .sort((a, b) => {
      if (a === b) duplicateVas = true;
    });

  const dealProduct = dealCartProducts.find(
    (cartProduct) =>
      cartProduct?.product?.__typename === labels.lbl_product_type_bundle
  );

  let outOfStockFlag = false;
  let applicationType;

  if (
    dealProduct?.customizable_options[0]?.values[0]?.label.toLowerCase() ===
    labels.deal_details.lbl_upgrade_deal_option_lower_case
  ) {
    applicationType = labels.deal_details.lbl_upgrade_deal_option;
  } else {
    applicationType = labels.deal_details.lbl_new_contract_deal;
  }

  const subTotalIncludingTax =
    cartDetails?.prices?.subtotal_including_tax?.value;

  const alertFlag =
    cartDetails?.totalQuantity > cartDetails?.cartLimits?.cart_qty_limit ||
    subTotalIncludingTax > cartDetails?.cartLimits?.order_value_limit ||
    cartProductItems.some(
      (cartProduct) =>
        cartProduct?.product?.stock_status === labels.lbl_out_of_stock
    ) ||
    (cartDetails?.isMulti && !features.multiCartEnabled) ||
    manyMonthlyDeals ||
    duplicateVas ||
    maxVas > 4;

  useEffect(() => {
    if (
      router.query &&
      router.query.login &&
      !profileLoading &&
      !userLoggedIn
    ) {
      let redirectURL =
        loginUrl + "?redirectUrl=" + window.location.href.split("?")[0];
      return window.location.replace(redirectURL);
    }
  }, [userLoggedIn, profileLoading]);

  useEffect(() => {
    setCartItems(cartProductItems);
    setAllPrices(prices);
  }, [cartProductItems, prices]);

  useEffect(() => {
    if (showSnackBar) {
      let timer = setTimeout(() => closeSnackBar(), 3000);
      return () => {
        clearTimeout(timer);
      };
    }
  }, [showSnackBar]);

  useEffect(() => {
    if (typeof window !== undefined) {
      setRedirectURL(window.location.href);
    }
    setRefreshUser(false);
    setIsUserProfileSync(false);
    resetSyncUserProfile();
    router.prefetch(`${urlPrefix}/shop`);
  }, []);

  useEffect(() => {
    async function updateCartValue() {
      setLoadingState(true);

      showGuestCart(cartId)
        .then((data) => {
          if (data?.status === 422) {
            handleCartActionFailure(data, fetchProductItems, handleProfileSync);
            setLoadingState(false);
          } else {
            if (updateCartDetails.includes("beforeCheckout")) {
              checkStockStatusBeforeCheckout(data)
                .then((stockStatus) => {
                  if (stockStatus && stockStatus.some((item) => item.outOfStock)) {
                    // should not allow user to do checkout
                    return;
                  }

                  // should allow user to do checkout
                  setTimeout(() => {
                    handleCheckout();
                  }, 3000);
                })
                .catch((err) => {
                  console.log(
                    "An error occurred, unable to check stock status",
                    err
                  );
                  setLoadingState(false);
                });
            }

            fetchProductItems();
          }
        })
        .catch((err) => {
          console.log("An error occurred, unable to fetch showGuestCart", err);
          setLoadingState(false);
        });
    }

    if (cartId && updateCartDetails) {
      updateCartValue();
    }
  }, [updateCartDetails]);

  /**
   * To check each cart item is OUT_OF_STOCK or IN_STOCK
   * @param {*} cartData
   * @returns boolean values for each existing item
   */
  const checkStockStatusBeforeCheckout = (cartData) => {
    return new Promise((resolve) => {
      try {
        if (cartData) {
          const cartItemStockStatus = [];
          cartData.cart.items.map((item) => {
            if (item) {
              if (item.product.stock_status.includes("OUT_OF_STOCK")) {
                cartItemStockStatus.push({
                  productId: item.product.id,
                  variantId: undefined,
                  outOfStock: true,
                });
              } else {
                const selectedConfigurableOptions =
                  item.configurable_options.map(
                    (selectedItem) => selectedItem.value_id
                  );
                const getSelectedVariant = item.product.variants.map(
                  (variantItem) => {
                    const selectedVariant = variantItem.attributes.filter(
                      (vItem) => {
                        return selectedConfigurableOptions.some((sItem) => {
                          return sItem === vItem.value_index;
                        });
                      }
                    );

                    if (
                      selectedVariant.length ===
                      selectedConfigurableOptions.length
                    ) {
                      return variantItem;
                    }
                  }
                );

                if (getSelectedVariant.length) {
                  getSelectedVariant.map((vStatus) => {
                    if (vStatus) {
                      if (
                        vStatus.product.stock_status.includes("OUT_OF_STOCK")
                      ) {
                        cartItemStockStatus.push({
                          productId: item.product.id,
                          variantId: vStatus.product.id,
                          outOfStock: true,
                        });
                      } else {
                        cartItemStockStatus.push({
                          productId: item.product.id,
                          variantId: vStatus.product.id,
                          outOfStock: false,
                        });
                      }
                    }
                  });
                }
              }
            }
          });

          resolve(cartItemStockStatus);
        }
      } catch (error) {
        resolve([]);
      }
    });
  };

  const handleProfileSync = async () => {
    setLoadingState(true);

    const JWTtoken = getCookieValue("vod-web-auth-token");
    const cartId = getCookieValue("cart_id");
    const pageAction = "CartProductCard";

    const dataResult = await syncUserProfile({ JWTtoken, cartId, pageAction });
    if (dataResult.type === SYNC_USER_PROFILE_SUCCESS) {
      if (
        dataResult.requestPayload.cartId &&
        dataResult.requestPayload.cartId.length
      ) {
        const oAuthToken = getAuthToken(dataResult);
        if (oAuthToken) {
          fetchProductItems();
        }
      } else {
        const oAuthToken = getAuthToken(dataResult);

        if (oAuthToken) {
          const getLoggedInCardId = await getCustomerActiveCartService();
          if (
            getLoggedInCardId &&
            !getLoggedInCardId.fail &&
            getLoggedInCardId.length
          ) {
            setCookieConsentWrapper(
              "cart_id",
              [config.cookie_category.strictly_necessary],
              `document.cookie='cart_id=${getLoggedInCardId};path=/'`
            );

            fetchProductItems();
          }
        }
      }
    } else {
      fetchProductItems();
      resetSyncUserProfile();
      setLoadingState(false);
    }
  };

  useEffect(() => {
    resetGuestCart();
    if (cartId) fetchProductItems();
    Analytics.setAutoTagging(false);
  }, []);

  const fetchProductItems = async () => {
    const cartId = getCookieValue("cart_id");
    
    setLoadingState(true)

    await getShippingAndBilling(cartId);

    let viewed, product, ids;

    if (productsCookie) {
      viewed = JSON.parse(productsCookie);
      ids = viewed.map((product) => product.sku);
    }

    showGuestCart(cartId).then((guestCartProductsData) => {
      if (
        (guestCartProductsData && guestCartProductsData?.errors) ||
        guestCartProductsData?.status === 500
      ) {
        if (guestCartProductsData?.status === 422) {
          handleCartActionFailure(
            guestCartProductsData,
            fetchProductItems,
            handleProfileSync
          );
        } else {
          const cartNotEmpty = guestCartProductsData?.cart?.items?.some(
            (i) => i?.product
          );
          if (!cartNotEmpty || guestCartProductsData.status === 500) {
            setCartApiError(true);
          }
          const analyticsData = Analytics.getUtagData([
            "visitor_login_status",
            "visitor_customer_id",
            "visitor_subscription_type",
            "visitor_msisdn_hash",
          ]);
          Analytics.link({
            page_name: "shopping: cart",
            page_form_event: "error",
            page_errors: `${guestCartProductsData.errors
              ? guestCartProductsData.errors?.[0].message
              : ""
              }`,
            page_errors_code: `cart-dxl-p-pl-${guestCartProductsData.status}`,
          });
          Analytics.view({
            page_event: "view",
            page_name: "page not loaded error",
            page_channel: "shopping",
            page_master_tab: "personal",
            ...analyticsData,
          });
        }
      }

      if (guestCartProductsData) {
        if (guestCartProductsData?.cart?.items) {
          setCartItems(
            mapCartProductItems(guestCartProductsData?.cart?.items || [])
          );
        }

        if (guestCartProductsData?.cart?.prices) {
          setAllPrices(guestCartProductsData?.cart?.prices);
        }
        const userMetaData = Analytics.getProfileData(
          userLoggedIn,
          profileData
        );

        if (guestCartProductsData?.cart?.items?.length) {
          const sales_order_discount = [];
          const sales_product_category = [];
          const sales_product_id = [];
          const sales_product_price = [];
          const sales_product_quantity = [];
          const sales_promo_name = [];
          const page_tool_event = [];
          const page_tool_name = [];
          const stockStatus = [];

          const filteredCartProducts = mapCartProductItems(
            guestCartProductsData?.cart?.items || []
          );

          filteredCartProducts.forEach((item) => {
            const isDealProduct = item?.product?.is_deal_product === 1;
            let sales_order_discount_value = Math.abs(
              item?.prices?.row_total_original?.value -
              item?.prices?.row_total_including_tax?.value
            );
            sales_order_discount.push(`${sales_order_discount_value}`);
            sales_product_id.push(item?.product?.name);
            sales_product_price.push(
              `${isDealProduct
                ? item?.product?.monthly_recurring
                : item?.prices?.row_total_including_tax.value
              }`
            );
            sales_product_quantity.push(`${item?.quantity}`);
            sales_product_category.push(
              item?.product?.categories[item?.product?.is_deal_product]?.name
            );
            if (item?.product?.promotion_tag_label) {
              sales_promo_name.push(item?.product?.promotion_tag_label);
            } else {
              sales_promo_name.push("");
            }
            if (item?.product?.stock_status.toLowerCase() === "out_of_stock") {
              page_tool_event.push("use");
              page_tool_name.push("shopping:cart:out of stock");
            } else {
              page_tool_event.push("");
              page_tool_name.push("");
            }
            stockStatus.push(
              item.isDealProduct && item.isOutOfStock
                ? "no_longer_available"
                : item?.product?.stock_status.toLowerCase()
            );
          });

          const analyticsData = {
            page_event: "view",
            page_name: "shopping: cart",
            page_channel: "shopping",
            page_master_tab: "personal",
            sales_event: "cart_view, cart_open",
            sales_order_discount,
            sales_product_category,
            sales_product_id,
            sales_product_price,
            sales_product_quantity,
            sales_promo_name,
            out_of_stock: stockStatus,
            ...userMetaData,
          };

          analyticsData.multicart_flag = cartDetails?.isMulti ? true : false;
          Analytics.view(analyticsData);

          //check if there is at least 1 product that is Pre-order
          checkPreOrder(guestCartProductsData);
        } else {
          Analytics.view({
            page_event: "view",
            page_name: "shopping: cart",
            page_form_event: "error",
            page_errors: "You don't have anything in your cart right now",
            page_channel: "shopping",
            page_master_tab: "personal",
            sales_event: "cart_view,cart_open",
            sales_order_discount: "",
            sales_product_category: "",
            sales_product_id: "",
            sales_product_price: "",
            sales_product_quantity: ["0"],
            ...userMetaData,
          });
        }
      }
    });
    if (isArrayNotEmpty(viewed)) {
      product = await ajaxService.fetchGraphQLPOSTRequest(CartRecentProducts, {
        ids,
      });

      if (
        product &&
        product.products &&
        product.products.items &&
        product.products.items.length
      ) {
        setProductItems(product.products.items);

        //disable checkout button if different types of products in the cart
        let dealFound = product.products.items.filter(
          (item) => item.is_deal_product == 1
        );

        if (
          (dealFound.length !== 0 &&
            dealFound.length !== product.products.items.length) ||
          dealFound.length > 1
        ) {
          setContinueDisabled(true);
        } else {
          setContinueDisabled(false);
        }
      }
    }

    setLoadingState(false);
  };

  useEffect(() => {
    if (
      updatedCookieProduct &&
      updatedCookieProduct.length > 0 &&
      productItems.length > 0
    ) {
      let checkProduct, updatedProducts;

      checkProduct = productItems.some((products) =>
        updatedCookieProduct.some(
          (cookieProducts) => cookieProducts.sku === products.sku
        )
      );

      if (checkProduct) {
        updatedProducts = productItems
          .filter((products) =>
            updatedCookieProduct.some(
              (cookieProducts) => cookieProducts.sku === products.sku
            )
          )
          .sort(
            (a, b) =>
              updatedCookieProduct.findIndex((cookie) => cookie.sku === a.sku) -
              updatedCookieProduct.findIndex((cookie) => cookie.sku === b.sku)
          );

        const productCookie = updatedProducts.map((cookieProduct) => {
          const obj = {
            sku: cookieProduct.sku,
          };

          if (
            cookieProduct.__typename ===
            labels.lbl_product_typeName_configurable &&
            cookieProduct.variants &&
            cookieProduct.variants.length > 0
          ) {
            const cookieVariantConfig = updatedCookieProduct.find(
              (config) => config?.variantConfig?.sku === cookieProduct.sku
            );
            obj.variantConfig = cookieVariantConfig?.variantConfig;
          }
          return obj;
        });
        setUpdatedCookieProduct([...productCookie]);
      }
    }
    if (productItems.length > 0) {
      const cookieSkus = getCookieValue("rv_products");
      let parsedSkus;
      if (cookieSkus) {
        parsedSkus = JSON.parse(cookieSkus);
      }
      setProductsViewed(getProductsCookie(parsedSkus, productItems));
    }
  }, [productItems]);

  if (typeof window !== "undefined") {
    setCookieConsentWrapper(
      "products_cookie",
      [cookie_category.strictly_necessary],
      `document.cookie='products=${encodeURIComponent(
        JSON.stringify(updatedCookieProduct).replace(/'/g, "\\'")
      )};path=/'`
    );
  }

  const beforeCheckout = () => {
    const randomNumber = Math.floor(Math.random() * 10) + 1;

    setUpdateCartDetails(`beforeCheckout-${randomNumber}`);
    setCheckoutLogin(true);
  };

  const onlyOnceOffProducts = !cartDetails.contract && cartDetails.onceOff;
  let onlyOneDeal = cartDetails.contract && !cartDetails.onceOff;

  if (!onlyOneDeal) {
    let isVas = 0;
    let dealsSku;
    cartItems.forEach((item) => {
      if (item?.product?.is_deal_product === 1) {
        dealsSku = item?.product?.sku;
      }
      if (item?.monthly_recurring && item?.parent_product_sku == dealsSku) {
        isVas++;
      }
    });
    if (isVas > 0) {
      onlyOneDeal = true;
    }
  }

  const handleCheckout = () => {
    setLoadingState(true)

    const analyticsData = {
      page_name: "shopping: cart",
      page_channel: "shopping",
      page_master_tab: "personal",
      sales_event: "order_checkout",
      link_type: "o",
      link_name: "shopping: cart: checkout now",
      ...Analytics.getUtagData([
        "visitor_login_status",
        "visitor_subscription_type",
        "visitor_id_has",
        "visitor_msisdn_hash",
      ]),
    };

    Analytics.link(analyticsData);
    Cookie.remove("product_id");
    setCheckoutLogin(false);

    if (
      !profileLoading &&
      !userLoggedIn &&
      isArrayNotEmpty(monthlyCartProducts) &&
      monthlyCartProducts.length - maxVas === 1
    ) {
      if (typeof window !== undefined) {
        setRedirectURL(`${window.location.origin}${urlPrefix}/post-checkout`);
      }

      setShowLoginModal(true);
    } else if (
      userLoggedIn &&
      isArrayNotEmpty(monthlyCartProducts) &&
      monthlyCartProducts.length - maxVas === 1
    ) {
      if (applicationType === labels.deal_details.lbl_upgrade_deal_option) {
        if (features?.upgradeEnabled) {
          router.push(`${urlPrefix}/post-checkout`).then(() => {
            window.scrollTo(0, 0);
            setLoadingState(false);
          });
        } else {
          handoverUpgradeeSession(
            canReciveOTP,
            isChildAllowed,
            upgradeResponse
          );
          router.push(
            `https://www${legacyEnv}.vodacom.co.za/cloud/shopping/order-summary?salesChannel=Upgrade&dealId=${dealProduct?.product?.id}&dealSheetNumber=${dealProduct?.product?.sku}${isMiniApp ? "&miniApp=true" : ""}`
          );
        }
      } else {
        if (features?.addLineEnabled || features?.newLineEnabled) {
          router.push(`${urlPrefix}/post-checkout`).then(() => {
            window.scrollTo(0, 0);
            setLoadingState(false);
          });
        } else {
          router.push(
            `https://www${legacyEnv}.vodacom.co.za/cloud/${newRedirectURL}/order-summary?salesChannel=Contract&dealSheetNumber=${dealProduct?.product?.sku}${isMiniApp ? "&miniApp=true" : ""}`
          );
        }
      }
    } else if (!profileLoading && !userLoggedIn && onlyOnceOffProducts) {
      if (typeof window !== undefined) {
        setRedirectURL(`${window.location.origin}${urlPrefix}/checkout`);
      }

      setShowLoginModal(true);
    } else if (userLoggedIn && cartDetails?.isMulti) {
      router.push(`${urlPrefix}/post-checkout`).then(() => {
        window.scrollTo(0, 0);
        setLoadingState(false);
      });
    } else {
      router.push(`${urlPrefix}/checkout`).then(() => {
        window.scrollTo(0, 0);
        setLoadingState(false);
      });
    }

    const sales_order_discount = [];
    const sales_product_category = [];
    const sales_product_id = [];
    const sales_product_price = [];
    const sales_product_quantity = [];
    const sales_promo_name = [];
    cartProductItems.forEach((item) => {
      sales_order_discount.push(`${getAmountOffValue(item?.product)}`);
      sales_product_id.push(item?.product?.name);
      sales_product_price.push(`${getFinalPrice(item?.product)}`);
      sales_product_quantity.push(`${item?.quantity}`);
      sales_product_category.push(item?.product?.categories?.[0]?.name);
      if (item?.product?.promotion_tag_label) {
        sales_promo_name.push(item?.product?.promotion_tag_label);
      } else {
        sales_promo_name.push("");
      }
    });

    setLoadingState(false);
  };

  const handleApplyCode = async (code) => {
    if (text === "") return;
    
    setLoadingState(true);

    const result = await addCouponToCart(cartId, code);

    setLoadingState(false);

    if (
      (result &&
        result.errors &&
        result.errors.length > 0 &&
        result.errors[0].message &&
        result.errors[0].message === labels.lbl_magento_invalid_coupon_error) ||
      (result &&
        result.errors &&
        result.errors.length > 0 &&
        result.errors[0].message)
    ) {
      window.scrollTo(0, 0);
      setShowCouponAlert(true);
      Analytics.link({
        page_name: "shopping: cart",
        page_form_name: "shopping: cart: voucher",
        page_form_event: "error",
        page_errors: labels.lbl_magento_invalid_coupon_error,
        page_errors_code: `cart-dxl-p-ac-${result.status}`,
        sales_voucher_name: code,
      });
    } else {
      setShowCouponAlert(false);
    }
    if (result && !result.errors) {
      closePromoModal();
      setUpdateCartDetails("addedCoupon");
      setUpdateMsg(false);
      setRemoveMsg(false);
      setRemoveCoupon(false);
      setShowSnackBar(true);
      setAddCoupon(true);
      setIsDealRemove(false);
      setText("");
      const sales_order_discount = [];
      const sales_product_category = [];
      const sales_product_id = [];
      const sales_product_price = [];
      const sales_product_quantity = [];
      const sales_promo_name = [];
      const sales_voucher_discount = [];

      cartProductItems.forEach((item) => {
        sales_product_id.push(item?.product?.name);
        sales_product_price.push(
          `${item?.prices?.row_total_including_tax.value}`
        );
        sales_product_quantity.push(`${item?.quantity}`);
        sales_product_category.push(item?.product?.categories?.[0]?.name || "");
        let sales_order_discount_value = Math.abs(
          item?.prices?.row_total_original?.value -
          item?.prices?.row_total_including_tax?.value
        );
        sales_order_discount.push(`${sales_order_discount_value}`);
        if (item?.product?.promotion_tag_label) {
          sales_promo_name.push(item?.product?.promotion_tag_label);
        } else {
          sales_promo_name.push("");
        }
      });
      const totalValue =
        result?.applyCouponToCart?.cart?.prices?.grand_total?.value;
      result?.applyCouponToCart?.cart?.items.map((cartItem) => {
        sales_voucher_discount.push(
          `${cartItem?.prices?.total_item_discount?.value}`
        );
      });
      Analytics.link({
        ...Analytics.getUtagData([
          "page_name",
          "page_channel",
          "page_master_tab",
          "visitor_login_status",
          "visitor_msisdn_hash",
          "visitor_customer_id",
          "visitor_id_hash",
          "visitor_subscription_type",
        ]),
        sales_event: "sales_voucher_redemption",
        page_tool_event: "use",
        page_tool_name: "shopping: cart: add voucher",
        sales_voucher_name: code,
        sales_product_category,
        sales_product_price,
        sales_product_quantity,
        sales_order_discount,
        sales_promo_name,
        sales_product_id,
        sales_order_sub_total: `${totalValue}`,
        sales_voucher_discount,
      });
      setVoucherAnalytics({ sales_voucher_discount });
    }
  };

  const hideCouponAlert = () => {
    setShowCouponAlert(false);
  };

  const showPromoModal = () => {
    setShowModal(true);
  };
  const closePromoModal = () => {
    setShowModal(false);
  };

  const renderPromoCodeSection = (
    <>
      <PromoTextCard
        label={labels.lbl_promocode_query}
        placeholder={labels.lbl_enter_promo}
        img_url={`${imagePrefix}/assets/images/caret-right.svg`}
        img_width={11}
        img_height={11}
        onSelect={showPromoModal}
        className="promo-section"
      />
      <TextBoxCard
        text={text}
        label={labels.lbl_promocode_query}
        placeHolder={labels.lbl_enter_promo}
        buttonText={labels.lbl_apply_code}
        buttonHandler={handleApplyCode}
        className="promo-section-box"
        handleChange={handleChange}
      />
      {isTablet && (
        <CustomContainer className="border-style" />
      )}
    </>
  );

  const urlRedirect = (url) => {
    if (url.includes("internal:")) {
      url = url.split("internal:")[1];
    }
    router.push(`${urlPrefix}${url}`).then(() => {
      window.scrollTo(0, 0);
      setLoadingState(false);
    });
  };

  const goToProducts = () => {
    setLoadingState(true);
    urlRedirect(startEmptyCart?.callToActionUri);

    Analytics.link({
      link_type: "o",
      link_name: "shopping: cart: start shopping",
      ...Analytics.getUtagData([
        "page_name",
        "page_channel",
        "page_master_tab",
        "visitor_login_status",
        "visitor_msisdn_hash",
        "visitor_customer_id",
        "visitor_id_hash",
        "visitor_subscription_type",
      ]),
    });
  };

  const closeSnackBar = () => {
    setShowSnackBar(false);
  };

  const emptyContainer = (
    <CustomContainer className="mainContainer">
      <Image
        img_path={startEmptyCart?.icon}
        img_width="5rem"
        img_height="5rem"
      />
      <LabelText className="content">{startEmptyCart?.title}</LabelText>
      <CustomContainer className="buttonContainer">
        <CTAButton
          className="roundBtn"
          variant={btnConfig.buttonStyle}
          handleClick={goToProducts}
          id={startEmptyCart?.callToActionLabel}
        >
          {startEmptyCart?.callToActionLabel}
        </CTAButton>
      </CustomContainer>
    </CustomContainer>
  );

  const renderInvalidCouponAlert = () => {
    const customProps = {};
    if (positionFromTop) {
      customProps.customStyle = { top: (isMobile || isTablet) && showModal ? 0 : positionFromTop };
    } else {
      customProps.className = "error_tool_tip";
    }
    return (
      <ErrorTooltip
        errorMsg={
          errorMsg === labels.lbl_magento_invalid_coupon_error
            ? labels.lbl_invalid_coupon
            : errorMsg
        }
        buttonHandler={hideCouponAlert}
        type="warning"
        {...customProps}
      />
    );
  };

  const chkOutOfStockItems = () => {
    return cartDetails.cartProductItems.every((e) => e.isOutOfStock === true);
  };

  const renderOutOfStockMessage = () => {
    let scenario = 0;
    let errMsg = errorMessages.out_of_stock.any_out_of_stock;
    /*
               1: // standalone out of stock
               2: // Low stock
               3: // Postpaid only - Backorder
               - 4: // Multi - Postpaid on backorder
               5: // Multi - Once-off out of stock
               - 6: // Multi - contract out of stock x
               7: // Multi - Both out of stock
               8: // Multi - Postpaid on pre-order
               9: // Contract only out of stock
              10: // Only one type product allowed
              11: // Only one deal allowed
              12: // Only unique vas allowed
              13: // Only 4 vas allowed
              14: // Both standalone and deal out of stock
        */

    if (!cartDetails?.isMulti && cartDetails?.contractMissed) {
      scenario = 9;
    }
    if (cartDetails?.onceOffMissed) {
      scenario = cartDetails?.isMulti ? 5 : 1;
      outOfStockFlag = true;
    }
    if (cartDetails?.contractMissed) {
      scenario = cartDetails?.isMulti ? 6 : 3;
      if (!cartDetails?.hasBackOrder) {
        outOfStockFlag = true;
      }
    }
    if (
      cartDetails?.isMulti &&
      cartDetails?.contractMissed &&
      cartDetails?.onceOffMissed
    ) {
      scenario = 7;
    }
    if (cartDetails?.hasPreOrder) {
      scenario = 8;
    }

    if (
      cartDetails?.isMulti &&
      !features.multiCartEnabled &&
      typeof features.multiCartEnabled === "boolean"
    ) {
      scenario = 10;
      errMsg = labels.lbl_only_one_type_product;
    }
    if (manyMonthlyDeals) {
      scenario = 11;
      errMsg = labels.lbl_only_one_deal_allowed;
    }
    if (duplicateVas) {
      scenario = 12;
      errMsg = labels.lbl_only_uniq_vas_allowed;
    }
    if (!manyMonthlyDeals && chkOutOfStockItems() && cartDetails?.isMulti) {
      scenario = 14;
      errMsg = errorMessages.out_of_stock.any_out_of_stock;
    }

    return (
      (scenario > 0 || cartDetails.hasBackOrder) && (
        <CustomContainer>
          {[5, 7, 10, 11, 12, 13, 14].indexOf(scenario) !== -1 && (
            <InfoBox
              type="error"
              imageSrc={`${imagePrefix}/assets/images/error-circle.svg`}
              imageWidth="1.3125rem"
              imageHeight="1.3125rem"
              text={errMsg}
            />
          )}

          {[3, 9].indexOf(scenario) !== -1 && (
            <InfoClickCollect
              type="info"
              imageSrc={`${imagePrefix}/assets/images/info_white.svg`}
              text={errorMessages.out_of_stock.collect_info}
            />
          )}

          {(cartDetails?.hasBackOrder || [3, 6, 7, 8, 9].indexOf(scenario)) !==
            -1 && (
              <InfoBox
                type="info"
                imageSrc={`${imagePrefix}/assets/images/info_white.svg`}
                imageWidth="1.3125rem"
                imageHeight="1.3125rem"
                text={errorMessages.out_of_stock.long_delivery}
              />
            )}
        </CustomContainer>
      )
    );
  };

  const checkIfEmpty = () => {
    const isNotEmpty =
      (cartItems && cartItems.length > 0) ||
      (allPrices &&
        allPrices.subtotal_including_tax &&
        allPrices.subtotal_including_tax.value &&
        allPrices.subtotal_including_tax.value > 0);
    return isNotEmpty;
  };

  const updateCartProduct = async (
    cartId,
    cartProductId,
    qty,
    name,
    isDealProduct
  ) => {
    const cartProductItemsData = getOptionsId(cartProductItems, cartProductId);
    const buyOptionId =
      cartProductItemsData?.[0]?.config_custom_options?.[0]?.id;
    const buyOptionTypeId =
      cartProductItemsData?.[0]?.config_custom_options?.[0]?.values?.[0]?.value;
    const attributesOptions = setOptionsAttributes(
      cartProductItemsData?.[0]?.configurable_options
    );

    const customizable_options =
      buyOptionId && buyOptionTypeId
        ? [
          {
            id: buyOptionId,
            value_string: buyOptionTypeId?.toString(),
          },
        ]
        : [];
    setCartProductName(name);

    setLoadingState(true);

    const result = await updateItemsofCart(
      cartId,
      cartProductId,
      qty,
      attributesOptions,
      customizable_options
    );

    setLoadingState(false);

    if (result?.updateCartItems?.cart) {
      setUpdateCartDetails("updateCartProduct");
      if (isDealProduct === 1) {
        setUpdateMsg(false);
        setIsDealRemove(true);
      } else {
        setUpdateMsg(true);
        setIsDealRemove(false);
      }
      setAddCoupon(false);
      setRemoveMsg(false);
      setRemoveCoupon(false);
      setShowSnackBar(true);
    }
  };

  const getOptionsId = (cartProductItemsData, cartProductIdValue) => {
    return cartProductItemsData.filter((item) => {
      return item.id === cartProductIdValue;
    });
  };

  const setOptionsAttributes = (optionsAttributes) => {
    let attributes = [];
    if (optionsAttributes) {
      optionsAttributes.forEach((list) => {
        attributes.push({
          id: list.id,
          value_string: list.value_id,
        });
      });
    }
    return attributes;
  };

  const removeCartProduct = async (
    cartId,
    cartProductId,
    name,
    isDealProduct
  ) => {
    setCartProductName(name);
    setLoadingState(true);

    const result = await deleteItemsFromCart(cartId, cartProductId);

    setLoadingState(false);

    if (
      addCouponMsg &&
      isArrayNotEmpty(onceOffCartProducts) &&
      onceOffCartProducts.length === 1 &&
      result?.removeItemFromCart?.cart
    ) {
      await removeCouponFromCart(cartId);
    }
    if (result?.removeItemFromCart?.cart) {
      setUpdateCartDetails("updateCartProduct");
      setAddCoupon(false);
      setUpdateMsg(false);
      if (isDealProduct === 1) {
        setRemoveMsg(false);
        setIsDealRemove(true);
      } else {
        setRemoveMsg(true);
        setIsDealRemove(false);
      }
      setRemoveCoupon(false);
      setShowSnackBar(true);
      checkPreOrder(result?.removeItemFromCart);
    }
  };

  const removeVoucherCode = async () => {
    setLoadingState(true);

    const salesVoucherName = cartDetails?.applied_coupons?.[0].code;
    const result = await removeCouponFromCart(cartId);

    setLoadingState(false);

    if (result?.removeCouponFromCart?.cart) {
      setUpdateCartDetails("removeVoucherCode");
      setAddCoupon(false);
      setUpdateMsg(false);
      setShowSnackBar(true);
      setRemoveMsg(false);
      setRemoveCoupon(true);
      setIsDealRemove(false);
      Cookie.remove("total_zero");
      Analytics.link({
        ...Analytics.getUtagData([
          "page_name",
          "page_channel",
          "page_master_tab",
          "visitor_login_status",
          "visitor_msisdn_hash",
          "visitor_customer_id",
          "visitor_id_hash",
          "visitor_subscription_type",
          "sales_voucher_name",
          "sales_product_category",
          "sales_product_price",
          "sales_product_quantity",
          "sales_order_discount",
          "sales_promo_name",
          "sales_product_id",
          "sales_voucher_discount",
        ]),
        sales_event: "sales_voucher_removal",
        page_tool_event: "use",
        page_tool_name: "shopping: cart: remove voucher",
        sales_order_sub_total: `${result?.removeCouponFromCart?.cart?.prices?.grand_total?.value}`,
        ...voucherAnalytics,
        sales_voucher_name: salesVoucherName,
      });
    }
  };

  const snackBarMsg = () => {
    let msg;
    if (addCouponMsg) {
      msg = labels.lbl_coupon_applied_successfully;
      return msg;
    }
    if (updateMsg) {
      msg = labels.lbl_updated_cart;
      return msg;
    }
    if (removeMsg) {
      msg = `${cartProductName} ${labels.lbl_removed_from_cart}`;
      return msg;
    }
    if (removeCoupon) {
      msg = labels.lbl_coupon_code_removed_successfully;
      return msg;
    }
    if (isDealRemove) {
      const productName =
        cartProductName.length > 20
          ? `${cartProductName.substr(0, 20)}...`
          : cartProductName;
      msg = `This ${productName} deal ${labels.lbl_deal_remove_from_cart}`;
      return msg;
    }
  };

  useEffect(() => {
    if (userProfileSync?.userDetails && userProfileSync?.userDetails != null) {
      setIsUserProfileSync(false);
      const { apiStatus } = userProfileSync?.userDetails;
      if (apiStatus && !refreshUser) {
        const cartId = getCookieValue("cart_id");
        updateCookieConsentWrapper(userProfileSync?.userDetails, cartId);
        setRefreshUser(true);
      } else {
        resetSyncUserProfile();
        setRefreshUser(false);
        if (userProfileSync?.userDetails?.apiFailStatus == "401") {
          clearUserToken();
          setTimeout(() => {
            window.location.replace(loginUrl + "?redirectUrl=" + redirectURL);
          }, 100);
          return;
        }

        setLoadingState(false);
      }
    }
  }, [userProfileSync]);

  const updateCookieConsentWrapper = (profileInfo, cartId) => {
    try {
      let oAuthToken =
        profileInfo?.result?.magentoProfileResponse[0]?.OAuthTokenDetails[0]
          ?.OAuthToken;
      cartId = profileInfo?.result?.magentoProfileResponse[0]?.mergedCartID;
      setCookieConsentWrapper(
        "auth_token",
        [config.cookie_category.strictly_necessary],
        `document.cookie='auth_token=${oAuthToken};path=/'`
      );
      setCookieConsentWrapper(
        "cart_id",
        [config.cookie_category.strictly_necessary],
        `document.cookie='cart_id=${cartId};path=/'`
      );
    } catch (error) {
      console.log("");
    } finally {
      const updatedProfileInfo = profileInfo?.result;
      setRefreshUser(false);

      setLoadingState(false);

      if (updatedProfileInfo) {
        setProfileData(profileInfo);
        // handleAddToCart();
        setIsUserProfileSync(false);
        resetSyncUserProfile();
      } else {
        setIsUserProfileSync(false);
        resetSyncUserProfile();
      }
    }
  };

  const errorMessagesLabel = {
    heading: labels.errorMessages.lbl_page_error,
    subHeading1: labels.errorMessages.lbl_page_error_subheading1,
    subHeading2: labels.errorMessages.lbl_page_error_subheading2,
  };

  const hideLoginModal = () => {
    setShowLoginModal(false);
  };

  const guestNavigation = () => {
    setLoadingState(true)

    router.push(`${urlPrefix}/checkout`).then(() => {
      window.scrollTo(0, 0);
      setLoadingState(false);
    });
  };

  const checkPreOrder = (cartData) => {
    let preOrderFound = cartData?.cart?.items.filter(
      (item) =>
        item.product.badges_label &&
        item.product.badges_label
          .toLowerCase()
          .indexOf(types.TYPE_PREORDER.toLowerCase()) > -1
    );
    if (preOrderFound && preOrderFound.length > 0) {
      if (!showPreOrderInfo) {
        fetchPreOrderContent();
      }
    } else {
      setShowPreOrderInfo(false);
    }
  };

  const fetchPreOrderContent = async () => {
    setLoadingState(true);

    try {
      const result = await ajaxService.httpGet(
        "drupalBaseUrl",
        "",
        "api",
        "preOrderProductInfo"
      );
      if (result?.sections[0]?.items) {
        setPreOrderDeliveryMessage(result.sections[0].items[0].description);
        setShowPreOrderInfo(true);
      }

      setLoadingState(false);
    } catch (e) {
      setLoadingState(false);
    } finally {
      setLoadingState(false);
    }
  };

  const captureRemovedVasAnalytics = (removedVasArray) => {
    if (removedVasArray && removedVasArray.length) {
      removedVasArray.forEach((cartProduct) => {
        const analyticsRemovedVas = {
          sales_event: "cart_remove",
          sales_order_discount: [getAmountOffValue(cartProduct?.product)],
          page_name: "shopping: cart",
          page_channel: "shopping",
          page_master_tab: "personal",
          link_type: "o",
          link_name: "shopping: cart: remove",
          sales_order_sub_total: cartProduct?.monthly_recurring,
          sales_product_category: [cartProduct?.product?.categories?.[0]?.name],
          sales_product_id: [cartProduct?.product?.name],
          sales_product_price: [cartProduct?.monthly_recurring],
          sales_product_quantity: [cartProduct.quantity],

          ...Analytics.getUtagData([
            "visitor_login_status",
            "visitor_subscription_type",
            "visitor_msisdn_hash",
            "visitor_id_hash",
          ]),
        };
        Analytics.link(analyticsRemovedVas);
      });
    }
  };

  const captureAddedVasAnalytics = (newlyAddedVasArray) => {
    if (newlyAddedVasArray && newlyAddedVasArray.length) {
      newlyAddedVasArray.forEach((cartProduct) => {
        const analyticsAddedVas = {
          sales_event: "cart_add",
          sales_order_discount: [getAmountOffValue(cartProduct?.product)],
          page_name: "shopping: cart",
          page_channel: "shopping",
          page_master_tab: "personal",
          link_type: "o",
          link_name: "shopping: cart: add",
          sales_order_sub_total: cartProduct?.price,
          sales_product_category: [
            cartProduct?.vasDetails?.categories?.[0]?.name,
          ],
          sales_product_id: [cartProduct?.name],
          sales_product_price: [cartProduct?.price],
          sales_product_quantity: [1],

          ...Analytics.getUtagData([
            "visitor_login_status",
            "visitor_subscription_type",
            "visitor_msisdn_hash",
            "visitor_id_hash",
          ]),
        };
        Analytics.link(analyticsAddedVas);
      });
    }
  };

  const handleAddRemoveToCartForVAS = async (selectedVasData) => {
    const dealData = cartItems.filter(
      (cartProduct) => cartProduct?.product?.is_deal_product === 1
    );
    const dealsSku = dealData[0].product.sku;
    const cartVasArray = cartItems.filter(
      (item) => item?.monthly_recurring && item?.parent_product_sku == dealsSku
    );

    const removedVasArray = [];
    const removedVasItem = [];
    for (const iterator of selectedVasData) {
      for (const cartVas of cartVasArray) {
        if (cartVas.product.sku === iterator.vidCode) {
          if (!iterator.isAdded) {
            removedVasArray.push(cartVas.id);
            removedVasItem.push(cartVas);
          }
        }
      }
    }

    const newlyAddedVasArray = selectedVasData.filter((mItem) => {
      return (
        !cartVasArray.some((cItem) => cItem.product.sku === mItem.vidCode) &&
        mItem.isAdded
      );
    });

    if (removedVasArray.length || newlyAddedVasArray.length) {
      if (cartId) {
        setLoadingState(true);
        setHideVasModal(true);

        const result = await updateTheCartWithVASProduct(
          cartId,
          dealsSku,
          removedVasArray,
          newlyAddedVasArray
        );
        if (result && result.status === 200) {
          setUpdateCartDetails(`addOrRemoveVAS_${Math.random()}`);
          setHideVasModal(false);
          captureRemovedVasAnalytics(removedVasItem);
          captureAddedVasAnalytics(newlyAddedVasArray);
        } else {
          setLoadingState(false);
        }
      }
    }
  };

  const redirectToNextSteps = () => {
    if (monthlyCartProducts.length > 0 || onceOffCartProducts.length > 0) {
      handleCheckout();
    }
  };

  useEffect(() => {
    if (Object.keys(features).length > 0) {
      if (userLoggedIn && isCheckoutLogin) {
        redirectToNextSteps();
      }
    }
  }, [features, monthlyCartProducts]);

  if (cartApiError) {
    return (
      <CustomContainer className="error-container">
        <ErrorCard errorMsg={errorMessagesLabel} fullWidth={1} />
      </CustomContainer>
    );
  }

  return (
    <>
      {showLoginModal && (
        <LoginModal
          show={showLoginModal}
          handleCancel={hideLoginModal}
          applicationType={onlyOnceOffProducts ? "normal" : "contract"}
          navigate={guestNavigation}
          redirectTo={redirectURL}
          setGuestCart={() =>
            addGuestCartProducts(
              cartItems,
              cartDetails.totalQuantity,
              cartDetails.applied_coupons
            )
          }
          resetGuestCart={() => addGuestCartProducts([], 0, null)}
        />
      )}

      {showSnackBar && (
        <SnackBar
          message={snackBarMsg()}
          className={
            addCouponMsg ? "snackBarStyling" : "defaultSnackBarStyling"
          }
          closeSnackBar={closeSnackBar}
          isVisible={showSnackBar}
          labelStyling={"msg-label"}
        />
      )}

      <Seo
        title={metadata?.title}
        content={metadata?.description}
        url={metadata?.canonical_url}
        keywords={metadata?.keywords}
        robots={metadata?.robots}
      />

      <Container className="main-container">
        <CustomContainer className="cart-container">
          {showCouponAlert ? renderInvalidCouponAlert() : <></>}
          <Row noGutters={true}>
            <Col md={12} className="p-0">
              <CustomContainer className="cart-container__top-spacing">
                <PageHeading
                  className="heading"
                  text={labels.lbl_your_cart}
                  level={3}
                />
              </CustomContainer>
            </Col>
          </Row>

          <Row noGutters={true}>
            <CustomContainer
              className={
                showCouponAlert ? "alertSpacing" : "cart-container__section"
              }
            >
              <Col md={12} className="p-0">
                {isPendingOrder && <PendingOrder className="pendingOrder" />}
              </Col>

              {checkIfEmpty() ? (
                <>
                  <Col lg={8} xl={8} className="cart-col-left">
                    {checkoutDisabled && (
                      <ErrorTooltip
                        type="not_allow_place_order"
                        errorMsg={errorMessages.not_allow_place_order}
                        hideDismissButton={true}
                      />
                    )}

                    {showPreOrderInfo && (
                      <CustomContainer className="pre-order-message-container">
                        <Image
                          className="pre-order-message-img"
                          img_path={`${imagePrefix}/assets/images/info_white.svg`}
                          img_width="1.125rem"
                          img_height="1.125rem"
                        />
                        <CustomContainer className="pre-order-message">
                          <span
                            dangerouslySetInnerHTML={createMarkup(
                              preOrderDeliveryMessage
                            )}
                          ></span>
                        </CustomContainer>
                      </CustomContainer>
                    )}

                    {renderOutOfStockMessage()}

                    <CustomContainer className="cart-container__section__left">
                      <CartListContainer
                        removeCartProduct={removeCartProduct}
                        updateCartProduct={updateCartProduct}
                        monthlyCartProducts={monthlyCartProducts}
                        onceoffCartProducts={onceOffCartProducts}
                        applicationType={applicationType}
                        alertFlag={alertFlag}
                        handleAddRemoveToCartForVAS={handleAddRemoveToCartForVAS}
                        shouldCloseModal={hideVasModal}
                      />
                    </CustomContainer>
                  </Col>

                  <Col lg={4} xl={4} className="cart-col-right">
                    <CustomContainer className="cart-container__section__right">
                      <CartOrderSummary
                        applicationType={applicationType}
                        disabledFlag={alertFlag || outOfStockFlag}
                        subTotal={`R${formatNumbersWithComma(
                          Math.round(
                            allPrices.subtotal_including_tax.value * 100
                          ) / 100
                        )}`}
                        delivery={
                          allPrices && allPrices?.subtotal_excluding_tax?.value
                            ? calculateShipping(
                              cartDetails,
                              allPrices.subtotal_excluding_tax.value
                            )
                            : null
                        }
                        vat={
                          allPrices && allPrices?.applied_taxes?.length > 0
                            ? `R${formatNumbersWithComma(
                              Math.round(
                                allPrices.applied_taxes[0].amount.value * 100
                              ) / 100
                            )}`
                            : null
                        }
                        total={getCartGrandTotal(cartDetails)}
                        handleCheckout={beforeCheckout}
                        checkoutDisabled={checkoutDisabled}
                        vatLabel={
                          allPrices &&
                            allPrices?.applied_taxes?.length > 0 &&
                            allPrices.applied_taxes[0].label
                            ? allPrices.applied_taxes[0].label
                            : labels.lbl_vat
                        }
                        removeVoucherCode={removeVoucherCode}
                        btnDisabled={continueDisabled}
                        monthlyCartProducts={monthlyCartProducts}
                        onceoffCartProducts={onceOffCartProducts}
                      />
                      {isArrayNotEmpty(onceOffCartProducts) &&
                        renderPromoCodeSection}
                    </CustomContainer>
                  </Col>
                </>
              ) : (
                emptyContainer
              )}

              {productsViewed && (
                <Col md={12} className="cart-col-footer p-s-8">
                  <CartFooter
                    recentViewed={productsViewed}
                    isCartEmpty={checkIfEmpty()}
                    triggerCallback={isUserProfileSync}
                    setUpdateCartDetails={setUpdateCartDetails}
                  />
                </Col>
              )}
            </CustomContainer>
          </Row>

          {checkIfEmpty() ? (
            <>
              <Row noGutters={true}>
                <Col md={12} className="p-0">
                  <CustomContainer className="cart-container__description">
                    <CartOrderDescription />
                  </CustomContainer>
                </Col>
              </Row>
              <Modal
                show={showModal}
                onHide={closePromoModal}
                dialogClassName={`custom-dialog ${!isMobile ? "modal-dialog-centered" : ""
                  } promo-code-modal `}
              >
                <TextBoxCard
                  isMobile={true}
                  onHide={closePromoModal}
                  text={text}
                  label={labels.lbl_promocode_query}
                  placeHolder={labels.lbl_enter_promo}
                  buttonText={labels.lbl_apply_code}
                  buttonHandler={handleApplyCode}
                  handleChange={handleChange}
                />
              </Modal>
            </>
          ) : (
            ""
          )}
        </CustomContainer>
      </Container>
    </>
  );
};

CartPage.propTypes = {
  recentlyViewed: PropTypes.array,
  cartProductItems: PropTypes.array,
  prices: PropTypes.object,
  metadata: PropTypes.object,
  addCouponToCart: PropTypes.func,
  errorMsg: PropTypes.string,
  cartDetails: PropTypes.any,
  userProfileSync: PropTypes.object,
  deleteItemsFromCart: PropTypes.func,
  updateItemsofCart: PropTypes.func,
  profileLoading: PropTypes.bool,
  removeCouponFromCart: PropTypes.func,
  getShippingAndBilling: PropTypes.func,
  showGuestCart: PropTypes.func,
  syncUserProfile: PropTypes.func,
  setProfileData: PropTypes.func,
  addGuestCartProducts: PropTypes.func,
  resetGuestCart: PropTypes.func,
  canReciveOTP: PropTypes.bool,
  isChildAllowed: PropTypes.bool,
  upgradeResponse: PropTypes.object,
  isMiniApp: PropTypes.bool,
  userLoggedIn: PropTypes.bool,
  profileData: PropTypes.object,
  isCheckoutLogin: PropTypes.bool,
  resetSyncUserProfile: PropTypes.func,
  setCheckoutLogin: PropTypes.func,
  setHelpLeadBucket: PropTypes.func,
  geoLocation: PropTypes.object,
  setChangeStore: PropTypes.func,
  setStoreDetails: PropTypes.func,
  setChangeMethods: PropTypes.func,
  checkFeatures: PropTypes.func,
  features: PropTypes.object,
};

CartPage.getInitialProps = async ({ req, query }) => {
  let recentlyViewed;
  const cookies = parseCookies(req);

  if (cookies && cookies.products) {
    recentlyViewed = JSON.parse(cookies.products);
  }

  let previewMode = query?.previewMode === "on";
  const seodata = await pageAPI.getPageComponents([
    `cart/CBU${query?.previewMode === "on"
      ? config.pageServiceQueryData.preview
      : config.pageServiceQueryData.status
    }`,
  ]);

  return {
    recentlyViewed,
    metadata: seodata?.seoMetadata,
    previewMode,
  };
};

const mapStateToProps = (state) => ({
  cartProductItems: state.cartDetails.cartProductItems,
  prices: state.cartDetails.prices,
  errorMsg: state.cartDetails.errorMsg,
  cartDetails: state.cartDetails,
  userLoggedIn: state.navDetails.isUserLoggedIn,
  profileData: state.navDetails.profileData,
  profileLoading: state.navDetails.isProfileLoading,
  isCheckoutLogin: state.navDetails.isCheckoutLogin,
  userProfileSync: state.userProfileSync,
  canReciveOTP: state.upgrade.canReciveOTP,
  isChildAllowed: state.upgrade.isChildAllowed,
  upgradeResponse: state.upgrade.upgradeResponse,
  geoLocation: state.geoLocation,
  isMiniApp: state.navDetails.isMiniApp,
  setHelpLeadBucket: PropTypes.func,
  features: state.common.features,
});

export default connect(mapStateToProps, {
  addCouponToCart,
  deleteItemsFromCart,
  updateItemsofCart,
  removeCouponFromCart,
  getShippingAndBilling,
  showGuestCart,
  resetSyncUserProfile,
  syncUserProfile,
  setProfileData,
  setCheckoutLogin,
  addGuestCartProducts,
  resetGuestCart,
  setHelpLeadBucket,
  setChangeStore,
  setStoreDetails,
  setChangeMethods,
  checkFeatures,
})(CartPage);
